import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './site-container.module.scss'

interface SiteContainerProps extends HTMLAttributes<HTMLDivElement> {
  bannerSpacing?: boolean
  ImageProps?: boolean
}

export const SiteContainer: FC<SiteContainerProps> = ({
  bannerSpacing,
  ImageProps,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      classes.siteContainer,
      {
        [classes.bannerSpacing]: bannerSpacing,
        [classes.imageRow]: ImageProps,
      },
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export default SiteContainer
